export function esc(str) {
  return String(str)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

export function renderMarkdown(text) {
  if (!text) return '';
  let s = String(text)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

  // Code blocks
  s = s.replace(/```[\s\S]*?```/g, m => {
    const inner = m.slice(3, -3).replace(/^\w+\n/, '');
    return `<pre><code>${inner}</code></pre>`;
  });
  // Inline code — bare URLs become links
  s = s.replace(/`([^`\n]+)`/g, (_, inner) => {
    if (/^https?:\/\/[^\s]+$/.test(inner.trim())) {
      const url = inner.trim();
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    }
    return `<code>${inner}</code>`;
  });
  // Bold
  s = s.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  // Italic
  s = s.replace(/(?<!\*)\*(?!\*)(.+?)(?<!\*)\*(?!\*)/g, '<em>$1</em>');
  // Markdown links
  s = s.replace(/\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g,
    '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');

  // Linkify — protect existing tags; render image URLs as <img> inline
  {
    const IMG_EXT = /\.(png|jpe?g|gif|webp|svg|avif)(\?[^\s]*)?$/i;
    const blocks = [];
    const protect = (html) => { const k = `__MC_BLOCK_${blocks.length}__`; blocks.push(html); return k; };
    s = s.replace(/<a[\s\S]*?<\/a>/g, protect);
    s = s.replace(/<pre[\s\S]*?<\/pre>/g, protect);
    s = s.replace(/<code>[\s\S]*?<\/code>/g, protect);
    s = s.replace(
      /(https?:\/\/[^\s<]+[^\s<\]\)\}\.,;:'"!?])/g,
      m => IMG_EXT.test(m)
        ? `<img class="mc-inline-img" src="${m}" alt="" loading="lazy" />`
        : `<a href="${m}" target="_blank" rel="noopener noreferrer">&#x1F517; ${m}</a>`
    );
    for (let i = 0; i < blocks.length; i++) s = s.replace(`__MC_BLOCK_${i}__`, blocks[i]);
  }

  // Blockquotes
  s = s.replace(/(^|\n)&gt; ?(.+)/g, '$1<blockquote>$2</blockquote>');
  // Lists
  s = s.replace(/((?:(?:^|\n)- .+)+)/g, block => {
    const items = block.trim().split('\n').map(l => `<li>${l.replace(/^- /, '')}</li>`).join('');
    return `<ul>${items}</ul>`;
  });
  // Line breaks
  s = s.replace(/\n/g, '<br>');
  return s;
}
